export default __webpack_public_path__ + "static/media/mockrocket-capture.0f55fb8c.png";